import { render, staticRenderFns } from "./Artifacts.vue?vue&type=template&id=7eee9492&scoped=true&"
import script from "./Artifacts.vue?vue&type=script&lang=js&"
export * from "./Artifacts.vue?vue&type=script&lang=js&"
import style0 from "./Artifacts.vue?vue&type=style&index=0&id=7eee9492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eee9492",
  null
  
)

export default component.exports